import type { StoreState } from './types/state';

export function createInitialState(): StoreState {
  return {
    // 登录凭证
    token: '',
    // 游客ID
    visitorId: '',
    // 不勾选的购物车id列表
    uncheckList: [],
    // 购物车列表对象
    cartInfor: { list: [], can_not_sell_list: [] },
    // 币种列表
    currencyList: [],
    // 当前币种 (默认值用来服务端渲染使用)
    currency: {
      name: 'USD',
      symbol: '$',
      full_symbol: '$',
      symbol_prefix: '$',
      symbol_suffix: '',
      img_url: 'https://cdn.vooglam.com/product/a7d7c179b8461f6e045b5dd8634c617d.png',
      exchange_rate: '1.000000',
    },
    // 后台的商品设置
    productConfig: {},
    // 抽奖活动公共配置
    onGoingLottery: {},
    // 快捷注册弹窗配置
    floatingWindow: {},
    // 快捷注册弹窗内容配置
    registerCouponPopup: {},
    // 权益发放策略
    tactics: {},
    // 第二件半价魔方配置. Ps: 文案类设一个默认值，就不需要再用 ?.
    halfPriceRule: {
      btn_discount_text: '',
      display_discount_text: '',
      discount_text: '',
      description: '',
    },
    // 用户所有国家列表（含运费）
    countryList: [],
    // 用户处方列表
    prescriptionList: [],

    myPresData: { edit: 0, data: {} },
    // 地址列表
    addressList: [],
    // 用户信息
    userInfo: { point: 0, wish_num: 0, coupon_num: 0, member_level: 0, uuid: '' },
    // crm积分规则。设一个默认值，避免服务端报错
    crmPointRule: {
      obtain: { dollar: '1' },
      deduct: {},
      reward: {},
    },
    // 详情页弹窗map
    productDetailPopMap: {},
    // 会员权益
    vipEquity: {},
    // 各种状态下的订单数量
    orderNum: { unpaid: 0, processing: 0, shipped: 0, review: 0, closed: 0 },
    // 用户id
    userId: '',
    // 是否允许进入支付成功页（每次支付成功后限进入1次）
    payFlag: '',
    // 判断是否是点击黑五页面tab
    tabClick: false,
    // 三方登录是否强制授权
    thirdPartyLoginreRequest: 0,
    // 三方登录类型
    provider: '',
    // video是否暂停播放
    videoPlay: true,
    // 来源页面的路由名称（通过watch $route 的变化获得from的值）
    fromRouteName: '',
    fromRouteCnName: '', // 来源页面的路由神策名称（通过watch $route 的变化获得from的值）
    DMP_PAYMENT_UUID: '', // 1004777：DMP 下单转化埋点，支付页的uuid
    uuidOrderList: [], // uuid跟订单的关系列表
    // 当初次进入网站时，如果账号被删除，需要弹窗提醒并跳转到登录注册页，但是初次进入会调用多个接口，所以要控制401的弹窗提醒只提醒一次
    AlreadyShowErr: false,
    cartNormalLR: false, // 是否在购物车页使用了普通登录注册
    // 支付报错信息
    payErrorMsg: '',
    // 是否是VIP
    isVip: false,
    // 推广码
    reward: '',
    // 设置滚动
    scrollHash: {
      top: 0, // 滚动高度
      flag: false, // 是否滚动
      behavior: 'smooth', // 滚动效果 smooth 平滑滚动  instant 立即滚动
    },
    // 滚动距离
    scrollTop: 0,
    // selectLens
    lensData: {
      edit: 0,
      data: {},
    },
    // 获取运费
    carriage: {},
    // 是否打开活动顶通
    activityClose: true,
    // 监听顶通收起
    activityFlag: true,
    // 列表页筛选定位
    filterFixed: 0,
    // 试戴模特
    modelList: [],
    // 引导注册图片及跳转
    registerData: {
      registerImg: '',
      pc_jump_target: {},
    },
    showTrackOrderMask: 0, // 是否展示我的订单页面trackorder弹窗外部的mask
    // 倒计时秒数
    countTimeCoupon: {},
    klarnaSave: {}, // klarna 优惠。1006886: 运营短期内不上klarna优惠，前端不再调用klarna优惠配置接口。
    // windowLoaded: false, // window 的load事件是否加载完毕
    pageIsChange: '', // 浏览器窗口切换 in进入页面  out离开页面
    allowPayMethods: [], // 魔方后台配置的默认支付方式
    blindMode: false, // 是否开启盲人模式
    homeCouponShow: false, // 全局coupon的展开状态（目前只统计手动点击展开1次）
    isRouterPush: true, // 路由变更是push还是其他（replace或back）。作用：keepalive的页面用来判断是否返回到原位置
    commonCountry: [], // 填写地址-常用国家。（仅首次加载）
    currentYear: new Date().getFullYear(), // 当前年份
    systemTimestamp: null,
    frameSizeUnitInStore: 'mm',
    // 页面滚动时半隐藏右下角悬浮窗
    scrollIconHide: false,
    deskType: 'shulex', // 客服聊天工具类型，仅保留 shulex
    hasRefreshCart: false, // 关闭扭蛋机弹窗，刷新购物车
    surveyList: [], // 问卷调查列表
    surveyPopInfo: {}, // 问卷弹窗信息
    surveyFinalInfo: {}, // 当前点击的问卷
    questionDetailShow: false, // 问卷详情弹窗展示
    show_my_card: 0, // 个人中心 我的卡 入口是否开启。0不开启；1开启
    stateLotteryInfo: {}, // 抽奖活动信息
    stopWatchRoute: false, // 用于阻止监听路由跳转的一个flag, 用完就重置
    prSwitch: {
      // 处方识别开关
      open: 1, // 识别开关
      guideOpen: 2, // 引导说明开关
      loadAnimationTime: 15, // 加载动画时长
    },
    // showScanGuideMask: false, // 是否展示处方识别蒙层
    scanInfo: {
      // 处方识别的数据
      recordId: '', // 处方识别接口返回的recordid
      imageUrl: '', // 处方识别接口返回的图片url
    },
    ForgotPasswordShow: false, // 忘记密码弹窗
    isFromResetPassword: false, // 重置密码后的操作
    isLRDialogShow: false, // 常规注册登录弹窗是否弹出
    forgotDialogEmail: '', // 忘记密码点continue后的邮箱
    changeEmailSwitch: 'off', // 邮箱验证开关。off：关闭；on：开启
    trendRightNav: [], // trendBook系列页面右侧导航
    isCustomizeGlassesShow: false, // 配镜流程弹窗是否显示图标
    isRightNavDisplay: true, // RightNav 是否展示
    festivalQuizShowFooter: false, // 节日问答结果页是否展示底部按钮
    cartPriceInfo: {}, // 购物车价格信息
    isVisitedCart: false, // 是否访问过购物车
    shouldAlertSendGift: false, // 是否需要弹出送礼气泡
    isFirstEnterCart: true, // 是否是第一次进入购物车(session 级别。 刷新后重置)
    historyFreeGiftCartId: '', // 历史选中赠品id
    navigationInfo: {
      navigationType: 'push', // 导航类型
      pageStates: new Map(), // key: 完整路径, value: 页面状态
      navigationHistory: new Map(), // key: 导航历史索引, value: 完整路径
    }, // 导航信息
    isRightNavClick: false, // 是否点击过右上角导航
    // Review 获取优惠券弹窗
    reviewGetCouponDialog: {
      show: false,
      couponList: [],
    },
    seel: 2, // 仅在 state 为 2 时, 关闭 seel. 其他值或不设置均认为是开启状态
    allWishIds: [], // 用户收藏的所有商品ID列表。不分页
    marketingStatus: null, // 用户营销授权状态
    bffSsrData: {
      ding_tong_banner: null,
      logo: null,
      default_search: [],
      top_nav: null,
      foot_nav: null,
      compliance_policies: null,
      compliance_subscription_display: null,
    },
    bffCsrData: {
      contact_chat_open_time: null,
      search_recommended: {},
      search_faq: {},
    },
  };
}

export default createInitialState;
